<template>
  <b-row>
    <div class="col-md-6 col-sm-12">
      <div class="box" id="app">
        <div
          class="dropable bg-gray"
          @dragover="dragover"
          @dragleave="dragleave"
          @drop="drop"
        >
          <input
            type="file"
            multiple
            name="fields[assetsFieldHandle][]"
            id="assetsFieldHandle"
            class="hidden"
            @change="onChange"
            ref="file"
            accept=".pdf,.jpg,.jpeg,.png"
          />

          <label for="assetsFieldHandle">
            <h4>Seleccionar o arrastrar archivos</h4>
          </label>
        </div>
      </div>
      <b-row align-h="between" class="p-3">
        <span>
          Nota: El tamaño máximo de adjuntos es 200MB. Máximo de 10 adjuntos por
          carga.</span
        >
        <b-button variant="danger" @click="uploadFiles()">
          <b-spinner small v-if="isBusy && itemSelected == 'cargar'" class="align-middle"></b-spinner>
          <template v-else>
            <i class="bx bx-upload font-size-16 align-middle mr-2"></i>
            Cargar
          </template>          
        </b-button>
      </b-row>
      <b-row align-h="between" align-v="center" class="p-3">
        <b-progress
          class="back-color"
          :value="sizeValue"
          :max="maxSizeValue"
          variant="danger"
        ></b-progress>
        <span>{{ sizeValue }}/200MB</span>
      </b-row>
      <ul class="file" v-if="this.filelist.length" v-cloak>
        <li
          class="text-sm p-1"
          v-for="(file, index) in filelist"
          v-bind:key="file.name + '-' + index"
        >
          <b-row align-h="between">
            <b-row align-v="center">
              <i class="bx bx-file-blank medium"></i>
              {{ file.name }}
            </b-row>
            <b-row align-v="center">
              <b-form-input
                class="col-md-10"
                v-model="dataToSend.tags[index]"
                placeholder="Etiqueta"
              ></b-form-input>
              <i
                class="bx bx-x-circle remove"
                @click="remove(filelist.indexOf(file))"
              ></i>
            </b-row>
          </b-row>
        </li>
      </ul>
    </div>
    <div class="col-md-6 col-sm-12" >
      <b-table :fields="fields" :items="items" sticky-header head-variant="light" >
        <template #empty="">
          <h4>Sin Datos</h4>
        </template>
        <!-- Custom name file -->
        <template #cell(nombre)="data">
          {{ data.item.nombre }}
        </template>

        <!-- Custom tag file -->
        <template #cell(tag)="data">
          {{ data.item.tag }}
        </template>

        <!-- Additional download button -->
        <template #cell(acction)="data">
          <b-button variant="danger" @click="getFile(data)">
            <b-spinner small v-if="isBusy && itemSelected == data.index" class="align-middle"></b-spinner>
            <template v-else>
              <i class="bx bx-download font-size-16 align-middle mr-2"></i>
              Descargar
            </template>            
          </b-button>
        </template>
      </b-table>
    </div>
  </b-row>
</template>

<script>
import { filesMethods } from "@/state/helpers";
export default {
  props: {
    tipoObjeto: String,
    idObjeto: Number,
  },
  data() {
    return {
      filelist: [],
      maxSizeValue: 200,
      sizeValue: 0,
      uploadedSize: 0,
      dataToSend: { // TODO: check how improve this
        file: [],
        filesize: [],
        idobjeto: [],
        tags: [],
        tipoobjeto: [],
      },
      fields: [
        { key: "nombre", label: "Nombre" },
        { key: "tag", label: "Etiqueta" },
        { key: "acction", label: "" },
      ],
      items: [],
      isBusy: false,
      itemSelected: ""
    };
  },
  beforeMount() {
    this.getFiles();
  },
  methods: {
    ...filesMethods,
    onChange() {
      this.sizeValue = 0;
      this.dataToSend = {
        file: [],
        filesize: [],
        idobjeto: [],
        tags: [],
        tipoobjeto: [],
      };
      this.filelist = [...this.$refs.file.files];
      for (let i = 0; i < this.filelist.length; i++) {
        this.dataToSend.file.push(this.filelist[i]);
        this.dataToSend.filesize.push(this.filelist[i].size);
        this.dataToSend.idobjeto.push(this.idObjeto);
        this.dataToSend.tags.push("");
        this.dataToSend.tipoobjeto.push(this.tipoObjeto);
        this.sizeValue += this.getSizeOnMB(i);
      }
      this.sizeValue += this.uploadedSize;
      this.sizeValue = this.sizeValue.toFixed(2);
    },
    remove(i) {
      this.filelist.splice(i, 1);
    },
    getFiles() {
      this.getAllFiles({
        tipoobjeto: this.tipoObjeto,
        idobjeto: this.idObjeto,
      })
        .then((files) => {
          if(!files){
            this.$bvToast.toast(
              this.$t("error.obtener-archivos.content").toString(), {
              title: this.$t("error.obtener-detalle-caso.title").toString(),
              variant: "danger",
              solid: true,
            });
          }
          this.items = files;
          this.uploadedSize = 0;
          for (let i = 0; i < files.length; i++) {
            this.uploadedSize += parseFloat(files[i].filesize / 1024 / 1024);
          }
          this.sizeValue += this.uploadedSize;
          this.sizeValue = this.sizeValue.toFixed(2);
          this.isBusy = false;
          this.itemSelected = null;
        })
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      if (!event.currentTarget.classList.contains("bg-red")) {
        event.currentTarget.classList.remove("bg-gray");
        event.currentTarget.classList.add("bg-red");
      }
    },
    dragleave(event) {
      // Clean up
      event.currentTarget.classList.add("bg-gray");
      event.currentTarget.classList.remove("bg-red");
    },
    drop(event) {
      event.preventDefault();
      this.$refs.file.files = event.dataTransfer.files;
      this.onChange(); // Trigger the onChange event manually
      // Clean up
      event.currentTarget.classList.add("bg-gray");
      event.currentTarget.classList.remove("bg-red");
    },
    getSizeOnMB(i) {
      return this.filelist[i].size / 1024 / 1024;
    },
    uploadFiles() {
      this.isBusy = true;
      this.itemSelected = "cargar"
      let requests = [];
      for (let i = 0; i < this.filelist.length; i++) {
        let dataToSend = {
          file: this.dataToSend.file[i],
          filesize: this.dataToSend.filesize[i],
          idobjeto: this.dataToSend.idobjeto[i],
          tags: this.dataToSend.tags[i],
          tipoobjeto: this.dataToSend.tipoobjeto[i],
        };
        requests.push(this.addFile({ dataToSend, endpoint: "uploadfilecp" }));
      }
      Promise.all(requests)
      .then(() => {
            this.sizeValue = 0;
            this.dataToSend = {
              file: [],
              filesize: [],
              idobjeto: [],
              tags: [],
              tipoobjeto: [],
            };
            this.filelist = [];
            this.getFiles();
            this.isBusy = false;
            this.itemSelected = null;
          })
          .catch((err) => console.log(err));      
    },
    getFile(data) {
      this.isBusy = true;
      this.itemSelected = data.index;
      this.downloadFile({
        dataToSend: { id: data.item["id"] },
        endpoint: "downloadfilecp",
        name: data.item["nombre"]
      })
        .then(() => {
          this.isBusy = false;
          this.itemSelected = "";
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss">
.box {
  width: 100%;
  height: 12rem;

  border-style: dashed;
  border-color: #cecbcb;
  border-radius: 0.5rem;

  .dropable {
    border-radius: 0.5rem;
    height: 100%;
    width: 100%;
    .hidden {
      display: none;
    }
    label {
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 100%;
      height: 100%;
    }
  }

  .bg-gray {
    background-color: #eeeeee;
  }
  .bg-red {
    background-color: #eeaeae;
  }
}
ul.file {
  list-style: none;
  padding-left: 15px !important;
}
.remove {
  margin-left: 4px;
  font-size: 24px;
  cursor: pointer;
  color: #cecbcb;
  &:hover {
    color: #c48383;
  }
}
.medium {
  font-size: 24px;
}
.progress.back-color {
  background-color: #eeeeee;
  width: 88% !important;
}
.max{
  height: 25rem;
}
</style>